import React, { useState, useContext } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../../AuthContext';

export const EnableTwoFa = () => {
  const [qrCodeUrl, setQrCodeUrl] = useState('');
  const [code, setCode] = useState('');
  const [enabled, setEnabled] = useState(false);
  const { authState, setAuthState } = useContext(AuthContext);
  const token = authState.token;
  const navigate = useNavigate();
  console.log(authState, 'authState');

  // Step 1: Generate QR
  const handleEnableClick = async () => {
    try {
      const res = await axios.post(
        '/auth/enable-2fa',
        {},
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setQrCodeUrl(res.data.qrCodeImageUrl);
    } catch (err) {
      console.error('Error enabling 2FA', err);
      alert('Something went wrong in generating the QR code');
    }
  };

  // Step 2: Verify code
  const handleVerify = async () => {
    try {
      const res = await axios.post(
        '/auth/verify-2fa-setup',
        { token: code },
        { headers: { Authorization: `Bearer ${token}` } }
      );

      if (res.status === 200) {
        const updatedUser = { ...authState.user, twoFAEnabled: true };

        // ✅ Update global state
        setAuthState(prev => ({
          ...prev,
          user: updatedUser,
        }));

        // ✅ Persist to cookies
        import('js-cookie').then(({ default: Cookies }) => {
          Cookies.set('user', JSON.stringify(updatedUser), {
            expires: 365 * 20,
          });
        });

        setEnabled(true);
      } else {
        alert('Invalid code, please try again.');
      }
    } catch (err) {
      console.error('Verification failed', err);
      alert('Something went wrong while verifying.');
    }
  };

  return (
    <>
      <style>{`
        .page {
          display: flex;
          flex-direction: column;
          min-height: 100vh;
          background: #f9fafb;
          color: #111827;
          font-family: sans-serif;
        }
        header {
          border-bottom: 1px solid #e5e7eb;
          background: #fff;
        }
        .header-container {
          max-width: 1200px;
          margin: 0 auto;
          padding: 0 1rem;
          display: flex;
          align-items: center;
          justify-content: space-between;
          height: 64px;
        }
        .header-left {
          display: flex;
          align-items: center;
          gap: 8px;
        }
        .header-left svg {
          width: 32px;
          height: 32px;
          color: #2563eb;
        }
        .header-title {
          font-size: 1.125rem;
          font-weight: 700;
        }
        nav {
          display: flex;
          gap: 1.5rem;
          font-size: 0.875rem;
          font-weight: 500;
          color: #4b5563;
        }
        nav a {
          text-decoration: none;
          color: inherit;
        }
        nav a:hover {
          color: #111827;
        }
        .avatar {
          width: 40px;
          height: 40px;
          background: #d1d5db;
          border-radius: 50%;
        }
        main {
          flex-grow: 1;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 2rem 1rem;
        }
        .card {
          max-width: 400px;
          width: 100%;
          background: #fff;
          border-radius: 0.75rem;
          box-shadow: 0 4px 6px rgba(0,0,0,0.1);
          padding: 2rem;
          text-align: center;
        }
        .card h2 {
          font-size: 1.5rem;
          font-weight: 700;
          margin-bottom: 0.75rem;
        }
        .card p {
          color: #6b7280;
          margin-bottom: 1.5rem;
        }
        .btn {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 100%;
          background: #2563eb;
          color: white;
          font-weight: 600;
          padding: 0.75rem;
          border-radius: 0.5rem;
          border: none;
          cursor: pointer;
          transition: background 0.2s;
          font-size: 1rem;
        }
        .btn:hover {
          background: #1d4ed8;
        }
        .input {
          width: 100%;
          padding: 0.75rem;
          border: 1px solid #d1d5db;
          border-radius: 0.5rem;
          text-align: center;
          font-size: 1.125rem;
          margin-bottom: 1rem;
        }
        .qr {
          width: 160px;
          height: 160px;
          border-radius: 0.5rem;
          box-shadow: 0 4px 6px rgba(0,0,0,0.1);
          margin: 0 auto 1.5rem auto;
        }
        .success {
          color: #16a34a;
          font-weight: 700;
          font-size: 1.25rem;
          margin-bottom: 0.5rem;
        }
      `}</style>

      <div className="page">
        {/* Main Content */}
        <main>
          {enabled ? (
            // ✅ Show immediate success after verification
            <div
              className="card"
              style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '16px',
                alignItems: 'center',
              }}
            >
              <div className="success" style={{ fontSize: '1.7rem' }}>
                ✅ 2FA is now enabled!
              </div>
              <p style={{ fontSize: '1.4rem' }}>
                Your account is now protected with two-factor authentication.
              </p>
              <button
                onClick={() => navigate('/')}
                className="btn btn-secondary"
                style={{ background: '#142127' }}
              >
                Go to Home
              </button>
            </div>
          ) : authState.user.twoFAEnabled ? (
            <div className="card">
              <div className="success" style={{ fontSize: '1.7rem' }}>
                ✅ 2FA is already enabled!
              </div>
              <p style={{ fontSize: '1.4rem' }}>
                Your account is already protected with two-factor authentication.
              </p>
              <button
                onClick={() => navigate('/')}
                className="btn btn-secondary"
                style={{ background: '#142127' }}
              >
                Go to Home
              </button>
            </div>
          ) : (
            <div className="card">
              {!qrCodeUrl && (
                <>
                  <h2>Two-Factor Authentication</h2>
                  <p>
                    Enhance your account security by enabling two-factor authentication. This adds
                    an extra layer of protection.
                  </p>
                  <button
                    onClick={handleEnableClick}
                    className="btn btn-secondary"
                    style={{ background: '#142127' }}
                  >
                    <span style={{ marginRight: '8px' }}>📷</span> Generate QR Code
                  </button>
                </>
              )}

              {qrCodeUrl && (
                <>
                  <h2>Set up two-factor authentication</h2>
                  <p>Scan the QR code with your authenticator app, then enter the code below.</p>
                  <img src={qrCodeUrl} alt="QR Code" className="qr" />
                  <input
                    type="text"
                    value={code}
                    onChange={e => setCode(e.target.value)}
                    placeholder="Enter 6-digit code"
                    maxLength={6}
                    className="input"
                  />
                  <button
                    onClick={handleVerify}
                    className="btn btn-secondary"
                    style={{ background: '#142127' }}
                  >
                    <span style={{ marginRight: '8px' }}>✅</span> Verify and Enable
                  </button>
                </>
              )}
            </div>
          )}
        </main>
      </div>
    </>
  );
};
